package components.project.configuration.facility

import it.neckar.lizergy.model.financial.quote.ConfiguredOptionality

/**
 * Options of the online monitoring select: [ConfiguredOptionality.Optional] is offered only while it is the [current] value.
 */
fun onlineMonitoringOptions(current: ConfiguredOptionality): List<ConfiguredOptionality> {
  return buildList {
    add(ConfiguredOptionality.Selected)
    add(ConfiguredOptionality.NotSelected)
    if (current == ConfiguredOptionality.Optional) {
      add(ConfiguredOptionality.Optional)
    }
  }
}
